// Search Tasks
export const SEARCH_TASKS_REQUEST = 'SEARCH_TASKS_REQUEST';
export const SEARCH_TASKS_SUCCESS = 'SEARCH_TASKS_SUCCESS';
export const SEARCH_TASKS_FAILURE = 'SEARCH_TASKS_FAILURE';

// Fetch Task by ID
export const FETCH_TASK_REQUEST = 'FETCH_TASK_REQUEST';
export const FETCH_TASK_SUCCESS = 'FETCH_TASK_SUCCESS';
export const FETCH_TASK_FAILURE = 'FETCH_TASK_FAILURE';

// Create Task
export const CREATE_TASK_REQUEST = 'CREATE_TASK_REQUEST';
export const CREATE_TASK_SUCCESS = 'CREATE_TASK_SUCCESS';
export const CREATE_TASK_FAILURE = 'CREATE_TASK_FAILURE';

// Update Task
export const UPDATE_TASK_REQUEST = 'UPDATE_TASK_REQUEST';
export const UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS';
export const UPDATE_TASK_FAILURE = 'UPDATE_TASK_FAILURE';

// Delete Task
export const DELETE_TASK_REQUEST = 'DELETE_TASK_REQUEST';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const DELETE_TASK_FAILURE = 'DELETE_TASK_FAILURE';

// Reset States
export const RESET_TASK_STATE = 'RESET_TASK_STATE';

// Action Creators
export const searchTasksRequest = (params) => ({
    type: SEARCH_TASKS_REQUEST,
    payload: params
});

export const fetchTaskRequest = (id) => ({
    type: FETCH_TASK_REQUEST,
    payload: id
});

export const createTaskRequest = (boardId, data) => ({
    type: CREATE_TASK_REQUEST,
    payload: { boardId, data }
});

export const updateTaskRequest = (id, data) => ({
    type: UPDATE_TASK_REQUEST,
    payload: { id, data }
});

export const deleteTaskRequest = (id) => ({
    type: DELETE_TASK_REQUEST,
    payload: id
});

export const resetTaskState = () => ({
    type: RESET_TASK_STATE
});
